export const BUTTON_CLICK = 'BUTTON_CLICK';
export const DROPDOWN_CLICK = 'DROPDOWN_CLICK';
export const DROPDOWN_ITEM_CLICK = 'DROPDOWN_ITEM_CLICK';
